import { API } from "@swivl-mono/api-helper";

export class TimeHelper {
  static timeOffset = 0;
  lastSyncTime: Date | null = null;

  static async syncTime() {
    const start = Date.now();
    let serverTime = await API.Time.getTime();

    if (typeof serverTime === "string") {
      serverTime = new Date(serverTime);
    }

    console.info("serverTime :", serverTime, typeof serverTime);

    const end = Date.now();
    this.timeOffset = serverTime.getTime() + (end - start) / 2 - end;
    console.info(`Time synced. Offset: ${this.timeOffset} ms (Delta: ${serverTime.getTime() - end} ms)`);
  }

  static getSyncedDate() {
    return new Date(Date.now() + this.timeOffset);
  }

  static startSyncingTime() {
    this.syncTime();
    setTimeout(() => {
      this.syncTime();
    }, 60 * 1000); // Secondary sync after 1 minute. This is becuase often the first sync can be delayed due to network latency.
    setInterval(
      () => {
        this.syncTime();
      },
      60 * 5 * 1000,
    ); // Sync every hour
  }
}
